import React from "react";
import { View, TextInput, useWindowDimensions } from "react-native";
import { FaUser, FaLock } from "react-icons/fa";

const InputField = (props) => {
  const { width } = useWindowDimensions();
  const isMobile = width < 850;

  return (
    <View
      style={[
        { ...styles.container, ...props.customStyle },
        isMobile && { width: "80%", height: 40, alignSelf: "center" },
      ]}
    >
      <TextInput
        placeholderTextColor={"rgba(9, 16, 29, 1)"}
        style={[
          { ...styles.textInput, ...props.textStyle },
          isMobile && { fontSize: 14 },
        ]}
        defaultValue={props.defaultValue}
        {...props}
      />
      {props.igoreIcon &&
        (props.icon && props.icon === "username" ? (
          <FaUser style={{ marginLeft: 10, marginRight: 10, opacity: 0.7 }} />
        ) : (
          <FaLock style={{ marginLeft: 10, marginRight: 10, opacity: 0.7 }} />
        ))}
    </View>
  );
};

const styles = {
  container: {
    width: 300,
    height: 40,
    // borderWidth: 2,
    backgroundColor: "rgba(244, 246, 249, 1)",
    borderRadius: 3,
    // borderColor: "#13131388",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginVertical: 10,
  },
  textInput: {
    flex: 1,
    height: "100%",
    paddingHorizontal: 10,
    outline: "none",
    color: "rgba(9, 16, 29, 1)",
  },
};

export default InputField;
